// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>29</span>&nbsp;&nbsp;Take from me the way of falsehood;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;be gracious to me through your law.<br> </p> </div></div>";
// Exports
module.exports = code;